import * as React from 'react'

function IconCircle({
  color,
  isFill,
  props,
}: {
  color: string
  isFill: boolean
  props?: React.SVGProps<SVGSVGElement>
}) {
  return (
    <svg
      width={104}
      height={104}
      viewBox="0 0 104 104"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isFill ? (
        <>
          <g filter="url(#prefix__filter3_circle)">
            <path
              d="M52 104c28.719 0 52-23.281 52-52S80.719 0 52 0 0 23.281 0 52s23.281 52 52 52z"
              fill="#fff"
            />
            <path
              d="M52 104c28.719 0 52-23.281 52-52S80.719 0 52 0 0 23.281 0 52s23.281 52 52 52z"
              fill={color}
            />
            <path
              d="M52 96.711c24.694 0 44.712-20.018 44.712-44.711C96.712 27.306 76.694 7.289 52 7.289c-24.693 0-44.711 20.017-44.711 44.71 0 24.694 20.018 44.712 44.711 44.712z"
              stroke="#fff"
              strokeWidth={0.75}
              strokeMiterlimit={10}
            />
          </g>
          <defs>
            <filter
              id="prefix__filter3_circle"
              x={0}
              y={0}
              width={104}
              height={104}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feBlend
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation={5} />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2={-1}
                k3={1}
              />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
              <feBlend in2="shape" result="effect1_innerShadow" />
            </filter>
          </defs>
        </>
      ) : (
        <>
          <path
            d="M52 104c28.719 0 52-23.281 52-52S80.719 0 52 0 0 23.281 0 52s23.281 52 52 52z"
            fill="#fff"
          />
          <path
            d="M52 104c28.719 0 52-23.281 52-52S80.719 0 52 0 0 23.281 0 52s23.281 52 52 52z"
            fill={color}
          />
          <path
            d="M52 96.711c24.694 0 44.711-20.018 44.711-44.711 0-24.694-20.017-44.711-44.71-44.711-24.694 0-44.712 20.017-44.712 44.71 0 24.694 20.018 44.712 44.711 44.712z"
            fill="#fff"
          />
        </>
      )}
    </svg>
  )
}

export default IconCircle
